import { render, staticRenderFns } from "./MoveToBarRecursion.vue?vue&type=template&id=2b8d799c&"
import script from "./MoveToBarRecursion.vue?vue&type=script&lang=js&"
export * from "./MoveToBarRecursion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports